import SubLayout from "@/components/site/SubLayout";
import Breadcrumbs from "@/components/site/Breadcrumbs";
import BookContact from "@/components/site/BookContact";
import Seo from "@/seo/Seo";
import { breadcrumbSchema, localBusinessSchema, serviceSchema } from "@/seo/schemas";
import { SITE } from "@/data/site";

export default function BookPage() {
  const path = "/book";
  const title = "Book Mobile VIN Verification | Orange County & LA";
  const description = `Request a mobile VIN verification appointment for your car, truck, motorcycle, trailer or RV. Same-day availability in Orange County, Los Angeles and nearby areas. Call ${SITE.phone}.`;
  const schema = [
    breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Book Appointment", path }]),
    serviceSchema({ name: "Mobile VIN Verification Appointment", description, path }),
    localBusinessSchema(),
  ];

  return (
    <SubLayout>
      <Seo title={title} description={description} path={path} schema={schema} />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-8">
        <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Book Appointment", path }]} />
      </div>
      <BookContact standalone />
    </SubLayout>
  );
}
